import {
  FETCH_PRODUCTS_START,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_ERROR,
  FETCH_PRODUCT_START,
  FETCH_PRODUCT_SUCCESS,
  FETCH_PRODUCT_ERROR,
  FETCH_CATEGORIES_START,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORIES_ERROR
} from "../actions/productActions";

const initState = {
  products: [],
  currentProduct: null,
  categories: [],
  loading: {
    products: false,
    product: false,
    categories: false
  },
  error: {
    products: null,
    product: null,
    categories: null
  }
};

const productReducer = (state = initState, action) => {
  switch (action.type) {
    // Products
    case FETCH_PRODUCTS_START:
      return {
        ...state,
        loading: { ...state.loading, products: true },
        error: { ...state.error, products: null }
      };
    case FETCH_PRODUCTS_SUCCESS:
      return {
        ...state,
        products: action.payload,
        loading: { ...state.loading, products: false },
        error: { ...state.error, products: null }
      };
    case FETCH_PRODUCTS_ERROR:
      return {
        ...state,
        loading: { ...state.loading, products: false },
        error: { ...state.error, products: action.payload }
      };

    // Single Product
    case FETCH_PRODUCT_START:
      return {
        ...state,
        loading: { ...state.loading, product: true },
        error: { ...state.error, product: null }
      };
    case FETCH_PRODUCT_SUCCESS:
      return {
        ...state,
        currentProduct: action.payload,
        loading: { ...state.loading, product: false },
        error: { ...state.error, product: null }
      };
    case FETCH_PRODUCT_ERROR:
      return {
        ...state,
        loading: { ...state.loading, product: false },
        error: { ...state.error, product: action.payload }
      };

    // Categories
    case FETCH_CATEGORIES_START:
      return {
        ...state,
        loading: { ...state.loading, categories: true },
        error: { ...state.error, categories: null }
      };
    case FETCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: action.payload,
        loading: { ...state.loading, categories: false },
        error: { ...state.error, categories: null }
      };
    case FETCH_CATEGORIES_ERROR:
      return {
        ...state,
        loading: { ...state.loading, categories: false },
        error: { ...state.error, categories: action.payload }
      };

    default:
      return state;
  }
};

export default productReducer;
